import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mf-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {}
